// seitenFarben.js — Seitenfarben AO/AKA auf der Punktetafel (23.10.2026, To-do 546).
//
// Eingestellt in der Modus-Übersicht, Reiter „Anzeige / Display“, Felder
// „AO Farbe“ und „AKA Farbe“ (modus_display_config <modus>/schreiber, global
// als Grundlage). Die Turniertag-Tafel (components/leinwand/Punktetafel.jsx)
// nimmt daraus nur die Seitenfarben: AKA = rote Seite, AO = blaue Seite
// (wie im Schreiber: Kämpfer 1 AO, Kämpfer 2 AKA; auf der Matte rot/blau).
// Gold, Rahmen, Drache/Tiger und Schrift bleiben die abgenommene Optik.
//
// Ohne Einstellung sieht die Tafel aus wie bisher: die Werkswerte der
// Modus-Übersicht (#2196F3, #ef5350, früher #f44336) gelten als „nicht
// gewählt“ und ergeben die festen Tafelfarben.
//
// Beschriftungen (To-do 546, Nachtrag 23.10.2026): „AO Beschriftung“ und
// „AKA Beschriftung“ ersetzen die Schilder ROT/BLAU. Werkswerte AO/AKA und
// leere Felder ergeben ROT/BLAU wie bisher. Höchstens 8 Zeichen (wie das
// Eingabefeld), Längeres wird mit „…“ gekürzt, damit nichts überläuft.
//
// Wird auch vom Backend-Test gelesen (backend/utils/__tests__/seitenFarben.test.js).

const TAFEL_STANDARD = { rot: '#ef5350', blau: '#3b82f6' };
// Werkseinstellungen der Modus-Übersicht (DEFAULT_RUMBLE_CONFIG), früher und heute
const WERK = { aoColor: ['#2196f3'], akaColor: ['#ef5350', '#f44336'] };
const TAFEL_NAMEN = { rot: 'ROT', blau: 'BLAU' };
const WERK_NAMEN = { aoLabel: ['ao'], akaLabel: ['aka'] };
const NAME_MAX = 8;
const TEXT_HELL = '#ffffff';
const TEXT_DUNKEL = '#1a0d05';

const istHex = (w) => typeof w === 'string' && /^#[0-9a-f]{6}$/i.test(w.trim());

function leuchtdichte(hex) {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255)
    .map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
/** Kontrast zweier Farben nach WCAG (1 … 21). */
function kontrast(a, b) {
  const [x, y] = [leuchtdichte(a), leuchtdichte(b)].sort((p, q) => q - p);
  return (x + 0.05) / (y + 0.05);
}
/**
 * Schrift auf einer Seitenfarbe: weiß, solange Weiß mindestens 3:1 erreicht
 * (WCAG für große und fette Schrift; die Marken sind fett und in Versalien),
 * sonst dunkel. So bleiben die heutigen Farben (Rot 3,2:1, Blau 3,7:1) weiß.
 */
function textFarbe(hex) {
  if (!istHex(hex)) return TEXT_HELL;
  return kontrast(hex, TEXT_HELL) >= 3 ? TEXT_HELL : TEXT_DUNKEL;
}

function gewaehlt(wert, feld) {
  if (!istHex(wert)) return null;
  const w = wert.trim().toLowerCase();
  return WERK[feld].includes(w) ? null : w;
}

/** Beschriftung eines Schilds: eigene Einstellung oder null (dann ROT/BLAU). */
function beschriftung(wert, feld) {
  if (typeof wert !== 'string') return null;
  const w = Array.from(wert.replace(/\s+/g, ' ')).filter((ch) => ch.charCodeAt(0) > 31 && ch !== '\x7f').join('').trim();
  if (!w || WERK_NAMEN[feld].includes(w.toLowerCase())) return null;
  const z = Array.from(w);
  return z.length > NAME_MAX ? z.slice(0, NAME_MAX - 1).join('').trimEnd() + '…' : w;
}

/**
 * Seitenfarben und Schilder der Tafel aus einer Anzeige-Einstellung ({ aoColor, akaColor, aoLabel, akaLabel, … }).
 * @returns {{rot:string, blau:string, rotText:string, blauText:string, rotName:string, blauName:string}}
 */
function tafelFarben(cfg) {
  const c = cfg && typeof cfg === 'object' ? cfg : {};
  const rot = gewaehlt(c.akaColor, 'akaColor') || TAFEL_STANDARD.rot;
  const blau = gewaehlt(c.aoColor, 'aoColor') || TAFEL_STANDARD.blau;
  return {
    rot, blau, rotText: textFarbe(rot), blauText: textFarbe(blau),
    rotName: beschriftung(c.akaLabel, 'akaLabel') || TAFEL_NAMEN.rot,
    blauName: beschriftung(c.aoLabel, 'aoLabel') || TAFEL_NAMEN.blau,
  };
}

/** CSS-Variablen für .pt-wurzel */
function tafelVariablen(farben) {
  const f = farben || tafelFarben(null);
  return { '--pt-rot': f.rot, '--pt-blau': f.blau, '--pt-rot-text': f.rotText, '--pt-blau-text': f.blauText };
}

module.exports = { TAFEL_STANDARD, TAFEL_NAMEN, NAME_MAX, WERK, beschriftung, istHex, kontrast, textFarbe, tafelFarben, tafelVariablen };
